import React from 'react';
import Signin from "./Signin";
import SignupStudentDetailStep from "./SignupStudentDetailStep";
import SignupSchoolDetailStep from "./SignupSchoolDetailStep";
import SignupPasswordStep from "./SignupPasswordStep";
import ForgetPassword from "./ForgetPassword";
import asyncComponentHOC from "../../hoc/asynccomponent";
import {STUDENTLOGIN, STUDENTSIGNUP, STUDENTPASSWORDFORGOT, STEP_STUDENTPROFILESINGUP, STEP_SCHOOLPROFILESIGNUP, STEP_PASSWORDSIGNUP} from './const';
import * as ACTIONS from "./../../store/actions";
import { connect } from "react-redux";
import Spinner from 'react-bootstrap/Spinner'

class StudentAuth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: STUDENTLOGIN,
      signupStep: STEP_STUDENTPROFILESINGUP, 
      studentProfile: {},
      schoolProfile: {},
      loading: false
    };

    this.goToLogin = this.goToLogin.bind(this);
    this.goToSignup = this.goToSignup.bind(this);
    this.goToForgetPassword = this.goToForgetPassword.bind(this);
    this.goToSchoolProfile = this.goToSchoolProfile.bind(this);
    this.goToPasswordProfile = this.goToPasswordProfile.bind(this);
    this.goToStudentProfile = this.goToStudentProfile.bind(this);
  }
  
  goToLogin() {
    this.setState({page: STUDENTLOGIN, loading: true})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  goToForgetPassword() {
    this.setState({page: STUDENTPASSWORDFORGOT, loading: true})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  goToSignup() {
    this.setState({signupStep: STEP_STUDENTPROFILESINGUP, loading: true})
    this.setState({page: STUDENTSIGNUP})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  goToSchoolProfile() {
    this.setState({signupStep: STEP_SCHOOLPROFILESIGNUP, loading: true})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  goToStudentProfile() {
    this.setState({signupStep: STEP_STUDENTPROFILESINGUP, loading: true})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  goToPasswordProfile() {
    this.setState({signupStep: STEP_PASSWORDSIGNUP, loading: true})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  renderSignupStep(){
    switch (this.state.signupStep) {
      case STEP_STUDENTPROFILESINGUP:
         return <SignupStudentDetailStep goToLogin={this.goToLogin}  next={this.goToSchoolProfile}/>
      case STEP_SCHOOLPROFILESIGNUP:
        return <SignupSchoolDetailStep goToLogin={this.goToLogin} back={this.goToStudentProfile} next={this.goToPasswordProfile}/>
      case STEP_PASSWORDSIGNUP:
        return <SignupPasswordStep goToLogin={this.goToLogin} back={this.goToSchoolProfile}/>
      default:
        break;
    }
  }

  renderPage() {
    if(this.state.loading){
      return <div className="w-100 d-flex align-items-center justify-content-center loader" ><Spinner animation="grow" variant="primary" /></div>
    }
    switch (this.state.page) {
      case STUDENTLOGIN:
        return  <Signin goToSignup={this.goToSignup} goToForgetPassword={this.goToForgetPassword} goToStep={this.goToStep}/> 
      case STUDENTPASSWORDFORGOT:
        return  <ForgetPassword goToLogin={this.goToLogin}/>  
      case STUDENTSIGNUP:
        return  this.renderSignupStep()
      default:
        break;
    }
  }
  render() {
    // Workaround to replace URL
    window.history.replaceState(null, "Student Signin", "/")
    return this.renderPage()
  }
}

const mapStateToProps = (state) => {
  return {
    student_signup_data: state.authR.student_signup_data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setStudentSignUpData: (payload) =>
      dispatch(ACTIONS.setStudentSignupData(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StudentAuth);
